import Api from "../apiService";

class numeratorsApi {
  index(companyId, params = {}) {
    return Api.getRequest(
      `companies/${companyId}/numerators`,
      params,
      Api.authHeaders()
    );
  }

  show(companyId, numeratorId, params = {}) {
    return Api.getRequest(
      `companies/${companyId}/numerators/${numeratorId}`,
      params,
      Api.authHeaders()
    );
  }

  create(companyId, numeratorData) {
    return Api.postRequest(
      `companies/${companyId}/numerators`,
      numeratorData,
      Api.authHeaders()
    );
  }

  update(companyId, numeratorId, numeratorData) {
    return Api.patchRequest(
      `companies/${companyId}/numerators/${numeratorId}`,
      numeratorData,
      Api.authHeaders()
    );
  }
}

export default new numeratorsApi();
